import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import theme from '../../theme';
import Header from "../Header";
import { DashboardFooter } from "../layout/dashboard-ui";
import { Box, Button, LinearProgress, Modal, styles as styled, Tooltip } from '@mui/material/';
import { useNavigate, useNavigation } from 'react-router-dom';
// import "./styles.css";
import Slider from '@mui/material/Slider';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import {
  convertToPercent, getCompsetName, round, getNumDaysFromDateRange, safeReference, dateDiff,
  isString, isEmptyObj, getFromState, getTransformedSegments, getRestrictionsStr, getStringFromHTML,
  numberFormatForReport, truncate, isNumber, dateFormat, deepCopy, processColumnsNew, getAppData, divide, generateTable, getPermissions,
  getStayToSdly, getStayToComp, getFromSession, isDateInRange, getDemandImpactName, getDemandImpactColor, getSeriesById, checkLoginEnabled, addToSession
} from "../../app/util";
import { CloseSharp as CloseSharpIcon, Label } from '@mui/icons-material';
import moment from 'moment';
import { DateRangePicker } from 'react-date-range';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { format, addDays, differenceInDays } from 'date-fns';
import { FileUploader } from "react-drag-drop-files";
import DataService from "../../services/data.service";
import { error } from "highcharts";
import { fetchDataSimple } from "../../services/data.service";
import { UPDATE_STATE } from '../../actions/types';
import DynamicAlert from "./DynamicAlert";
import { AtuoLogoutTimer } from '../AutoLogoutTimer';
import { GRACE_TIME, TIME_OUT } from "../../app/config-v4-api";
const token = getFromSession("token");


const SigmaDashboard = (props) => {
  if (!checkLoginEnabled()) {
    localStorage.clear();
    sessionStorage.clear();
    window.top.location.href = '/login';
  }
  const controls = useSelector(state => state.app.current_state.app_state.workspace_controls);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const state = useSelector(state => state);
  const { auth, app } = state;
  const { profile } = auth;
  const {
    profile: { property_details },
    user,
  } = useSelector((state) => state.auth);

  const { app_state, ui_state } = useSelector(
    (state) => state.app.current_state
  );

  const username = (user && user.fullname) ? user.fullname : "";
  const { property_id } = app_state;
  const { propertyChangeErrorMsg } = ui_state;
  const { permissions } = getPermissions(property_details, property_id);
  let url = "pending...";
  const [urlStatus, setUrlStatus] = useState("pending");
  const reportTitle = useRef("");
  const hasSubmitted = useRef(false);

  function getReportLabel(report_id) {
    const reportLabels = {
      otb_ea: 'Business Intelligence',
      pickup_ea: 'Business Intelligence',
      flight_ea: 'Feeder Market Insights',
    };

    return reportLabels[report_id] || 'Feeder Market Insights.';
  }

  const formatWithCurrentTime = (dateStr) => {
    let now = moment();
    return moment(dateStr, "YYYY-MM-DD")
      .set({
        hour: now.hour(),
        minute: now.minute(),
        second: now.second(),
      })
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]");
  };

  const handleSubmit = (sigma_report_id = null) => {
    if (!sigma_report_id) return;
    setTimeout(() => {
      hasSubmitted.current = false;
    }, 2000);

    // let asOfDate = app_state.primary_stay_range.as_of_date;
    let pickupAsOfdate = moment(app_state.primary_stay_range.as_of_date).isBefore(moment(), "day") ? app_state.primary_stay_range.as_of_date : app_state.latest_data_asof;
    let asOfDate = (sigma_report_id && sigma_report_id === 'pickup_ea') ? app_state.latest_data_asof : pickupAsOfdate;
    asOfDate = moment(asOfDate).format("YYYY-MM-DD");//moment((sigma_report_id && ["pickup_ea", "otb_ea"].includes(sigma_report_id))? pickupAsOfdate : app_state.primary_stay_range.as_of_date).format("YYYY-MM-DD");

    // let as_Of_date = formatWithCurrentTime(asOfDate);
    let fromDate = app_state.primary_stay_range.date_from;
    let toDate = app_state.primary_stay_range.date_until;
    let apiUrl = "ea/s/url/?eaReportId=" + sigma_report_id +
      "&propertyId=" + app_state.property_id +
      "&asOfDate=" + asOfDate +
      "&startDate=" + encodeURIComponent(fromDate) +
      "&endDate=" + encodeURIComponent(toDate);

    // let apiUrl = `ea/s/url/?eaReportId=${sigma_report_id}&propertyId=${app_state.property_id}`;
    // if (!(sigma_report_id && sigma_report_id === 'pickup_ea')) {
    //   apiUrl += `&asOfDate=${asOfDate}`;
    // }
    // apiUrl += `&fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`;

    let request = { method: "GET" }
    fetchDataSimple({ api: apiUrl, request }).then(res => {
      setUrlStatus(res.url);
    })
    reportTitle.current = getReportLabel(sigma_report_id);
  }


  useEffect(() => {
    const propVariant = property_details.find(p => p.id === property_id)?.product_variant;
    const sigmaReportsArr = propVariant?.ea_reports;

    let sessionSigmaReportId = getFromSession("sigma_report_id");
    const stateSigmaReportId = localStorage.getItem('sigma_report_id');//app_state?.workspace_controls?.sigma_report_id;

    const tmpReportId = localStorage.getItem('tmp_report_id');
    if (tmpReportId) {
      sessionSigmaReportId = tmpReportId;
      addToSession("sigma_report_id", stateSigmaReportId);
      localStorage.removeItem('tmp_report_id');
    }

    let finalSigmaReportId = sessionSigmaReportId || stateSigmaReportId;
    if (finalSigmaReportId) {
      if (!sessionSigmaReportId && stateSigmaReportId) {
        addToSession("sigma_report_id", stateSigmaReportId);
      }

      if (!sigmaReportsArr.some(report => report.id === finalSigmaReportId) && finalSigmaReportId !== 'flight_ea') {
        finalSigmaReportId = sigmaReportsArr[0]?.id || null;
        addToSession("sigma_report_id", finalSigmaReportId);
      }

      setUrlStatus('');
      handleSubmit(finalSigmaReportId);
    } else {
      //setUrlStatus('no-access');

      // finalSigmaReportId = 'otb_ea';
      // addToSession("sigma_report_id", finalSigmaReportId);
      // setUrlStatus('');
      // handleSubmit(finalSigmaReportId);

      window.location.href = '/';
    }

    const timeout = setTimeout(() => {
      dispatch({
        type: UPDATE_STATE,
        payload: {
          app_state: {
            workspace_controls: {
              ...app_state.workspace_controls,
              sigma_report_id: finalSigmaReportId,
              sigmaDashboardUrl: ''
            }
          }
        }
      });
    }, 1000);

    hasSubmitted.current = true;

    // Cleanup timeout if needed
    return () => clearTimeout(timeout);

  }, [property_id]);




  // LRV-1119 - Handle mouse event on iframe contents
  let [reRender, setReRender] = useState(false);
  useEffect(() => {
    const handleWindowBlur = () => {
      // console.log("Window lost focus");
      setTimeout(() => {
        if (document.activeElement && document.activeElement.tagName === 'IFRAME') {
          // console.log('IFRAME CLICKED');
          setReRender(prev => prev ? false : true);
          setTimeout(() => {
            // window.focus();
            localStorage.setItem('userActive', JSON.stringify({
              status: 'true',
              updatedAt: Date.now(),
            }));
            // console.log('Window re-focused');
          }, 100);
        }
      }, 0); // slight delay allows activeElement to update
    };

    window.addEventListener("blur", handleWindowBlur);
    document.addEventListener("mousewheel", handleWindowBlur);
    document.addEventListener("mousemove", handleWindowBlur);
    return () => {
      window.removeEventListener("blur", handleWindowBlur);
      document.removeEventListener("mousewheel", handleWindowBlur);
      document.removeEventListener("mousemove", handleWindowBlur);
    };
  }, []);

  return (
    <>
      <AtuoLogoutTimer timeout={TIME_OUT} graceTime={GRACE_TIME} sigmaReport={true}> {/* LRV-1119 - Auto Logout Wrapper */}
        <ThemeProvider theme={theme}>
          {/* Header Start */}
          <Box>
            <Header />
          </Box>
          {/* Header End */}

          <Box sx={{ pt: "58px", height: "100%", background: "#f3f3f3" }}>
            {/* <Box className='top-axn-bar-1'>
              <Box className="event-page-title" style={{ justifyContent: "center", width: "100%" }}>
                {reportTitle.current || ''}
              </Box>
            </Box> */}

            {!['pending', 'no-access'].includes(urlStatus) && <iframe src={urlStatus} height="100%" width="100%" frameBorder={"none"} style={{ height: "calc(100% - 40px)", border: "none" }} />}
            {['pending'].includes(urlStatus) && <LinearProgress />}
            {['no-access'].includes(urlStatus) && <DynamicAlert purpose="no-access" showAlert={true} message="Don't have permission to access this report. Please contact to Administrator." />}
          </Box>
          {/* Footer Start */}
          <Box>
            <DashboardFooter />
          </Box>
          {/* Footer End */}
        </ThemeProvider>
      </AtuoLogoutTimer>
    </>
  )
}

export default SigmaDashboard
